/**
 * 空状态组件
 * 用于无数据、搜索无结果等场景
 */

import React from 'react';
import { Button } from 'antd';
import {
  InboxOutlined,
  SearchOutlined,
  FileTextOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import './EmptyState.css';

export interface EmptyStateProps {
  type?: 'no-data' | 'search' | 'error' | 'custom';
  title?: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  actionText?: string;
  onAction?: () => void;
  image?: React.ReactNode;
}

const defaultConfigs = {
  'no-data': {
    icon: <InboxOutlined style={{ fontSize: 64, color: 'var(--color-neutral-400)' }} />,
    title: '暂无数据',
    description: '还没有任何数据，点击下方按钮开始创建',
  },
  search: {
    icon: <SearchOutlined style={{ fontSize: 64, color: 'var(--color-neutral-400)' }} />,
    title: '未找到匹配结果',
    description: '请尝试使用其他关键词或调整筛选条件',
  },
  error: {
    icon: <FileTextOutlined style={{ fontSize: 64, color: 'var(--color-error-400)' }} />,
    title: '加载失败',
    description: '数据加载出现问题，请刷新页面重试',
  },
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  type = 'no-data',
  title,
  description,
  actionText,
  onAction,
  icon,
  action,
  image,
}) => {
  const config = defaultConfigs[type as keyof typeof defaultConfigs] || defaultConfigs['no-data'];

  const finalIcon = icon || image || config.icon;
  const finalTitle = title || config.title;
  const finalDescription = description || config.description;

  return (
    <div className="empty-state-container">
      <div className="empty-state-content">
        {/* 图标/插图 */}
        <div className="empty-state-icon">{finalIcon}</div>

        {/* 标题 */}
        <h3 className="empty-state-title">{finalTitle}</h3>

        {/* 描述 */}
        <p className="empty-state-description">{finalDescription}</p>

        {/* 操作按钮 */}
        {(action || (actionText && onAction)) && (
          <Button
            type="primary"
            size="large"
            icon={action?.icon || <PlusOutlined />}
            onClick={action?.onClick || onAction}
            className="empty-state-action"
          >
            {action?.label || actionText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;

